import { debounce, elapsedStart } from "../inc/helpers";

export default class Accordion {
    _container = null;
    _btn = null;
    _body = null;
    _bodyH = 0;
    _onResize = null;
    _isOpen = false;
    
    constructor() {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._body = this._container?.querySelector(".accordion-body");
        this._onResize = () => this._setBodyHeight();
        elapsedStart(this._onResize);
        window.addEventListener("resize", debounce(this._onResize));

        this._btn?.addEventListener("click", this._onBtnClick.bind(this));
    }   
    
    _setBodyHeight() {
        this._body?.classList.remove("h-0");
        this._body?.style.setProperty("--b-h", `${this._body.offsetHeight}px`);
        this._body?.classList.add("h-0");
        
        if (!this._isOpen)
            this._body?.setAttribute("inert", "");
    }

    _onBtnClick() {
        if (this._isOpen) {
            this._close();
        
        } else {
            this._open();
        }
    }

    open(bool) {
        bool ? this._open() : this._close();
    }

    _open() {
        this._isOpen = true;
        this._btn?.setAttribute("aria-expanded", this._isOpen);
        this._body?.removeAttribute("inert");
    }

    _close() {
        this._isOpen = false;
        this._btn?.setAttribute("aria-expanded", this._isOpen);
        this._body?.setAttribute("inert", "");
    }

    get isOpen() {
        return this._isOpen;
    }
}